<template>
    <div>
        <router-view />
    </div>
</template>

<script>
export default {
    name: "FormAdminInd",
};
</script>

<style lang="scss" scoped></style>
